import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';

import { router } from '@web/lib/react-router';
import { queryClient } from '@web/lib/react-query';
import { trpc, trpcClient } from '@web/lib/trpc';

import { Toaster } from '@web/components/ui/toaster';

import { AuthContextProvider, useAuthContext } from '@web/auth';

import '@web/styles.css';

function Router() {
  const auth = useAuthContext();
  return <RouterProvider router={router} context={{ auth }} />;
}

export function App() {
  return (
    <>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <AuthContextProvider>
            <Router />
          </AuthContextProvider>
        </QueryClientProvider>
      </trpc.Provider>

      <Toaster position="top-center" />
    </>
  );
}
